// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.snapping-toolbar {
    display: flex;
    flex-direction: column;
    align-items: center;
}

span.snapping-toolbar-label {
    font-size: 85%;
    white-space: nowrap;
}

div.snapping-toolbar-container div.spinner {
    width: 1.5em;
    height: 1.5em;
}


div.snapping-toolbar-inactive {
    color: var(--text-color-disabled);
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/map/style/SnappingSupport.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,iCAAiC;IACjC,kBAAkB;AACtB","sourcesContent":["div.snapping-toolbar {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\nspan.snapping-toolbar-label {\n    font-size: 85%;\n    white-space: nowrap;\n}\n\ndiv.snapping-toolbar-container div.spinner {\n    width: 1.5em;\n    height: 1.5em;\n}\n\n\ndiv.snapping-toolbar-inactive {\n    color: var(--text-color-disabled);\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
